import React, { useState } from 'react';
import ReactQuill from 'react-quill'; // Correct import of ReactQuill
import 'react-quill/dist/quill.snow.css'; // Import Quill styles

const PostBlog = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState(''); // Initialize as an empty string
  const [tags, setTags] = useState('');
  const [author, setAuthor] = useState('Krushna Nagare');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const tagsArray = tags.split(',').map(tag => tag.trim());

    const postData = {
      title,
      content,
      tags: tagsArray,
      author,
    };

    try {
      const response = await fetch('https://portfolio-kappa-taupe-99.vercel.app/blog/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      });

      if (response.ok) {
        alert('Blog post submitted successfully!');
        // Optionally reset form fields or redirect
      } else {
        alert('Failed to submit the blog post.');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while submitting the blog post.');
    }
  };

  const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }],
      ['bold', 'italic', 'underline'],
      [{ 'color': [] }, { 'background': [] }], // Add color and background options
      ['code-block'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'script': 'sub' }, { 'script': 'super' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'direction': 'rtl' }],
      ['link'],
      ['clean'] // remove formatting button
    ]
  };

  return (
    <div className="post-blog-container">
      <h1 className="post-blog-header">Post a Blog</h1>
      <form onSubmit={handleSubmit} className="post-blog-form">
        <div className="post-blog-form-group">
          <label htmlFor="title" className="post-blog-label">Title:</label>
          <input
            type="text"
            id="title"
            className="post-blog-input"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="post-blog-form-group">
          <label htmlFor="content" className="post-blog-label">Content:</label>
          <ReactQuill
            theme="snow"
            value={content}
            onChange={(value) => setContent(value)}
            modules={modules} // Pass the modules configuration
            className="post-blog-quill"
          />
        </div>
        <div className="post-blog-form-group">
          <label htmlFor="tags" className="post-blog-label">Tags (comma-separated):</label>
          <input
            type="text"
            id="tags"
            className="post-blog-input"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            required
          />
        </div>
        <div className="post-blog-form-group">
          <label htmlFor="author" className="post-blog-label">Author:</label>
          <input
            type="text"
            id="author"
            className="post-blog-input"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
            readOnly
          />
        </div>
        <button type="submit" className="post-blog-button">Submit</button>
      </form>
    </div>
  );
};

export default PostBlog;
